import {
    Cell,
    Desc,
    Divider,
    FooterStats,
    HeaderMainTitle,
    HeaderTitle,
    IconBlock,
    Part,
    Row,
    Stat,
    Table,
    Temp,
} from "./style";
import {CloudIcon} from "../../../shared/ui/icons/cloudIcon";
import {Drop} from "../../../shared/ui/icons/drop.tsx";
import {Disk} from "../../../shared/ui/icons/Disk.tsx";
import {SchedulePart, ScheduleRow} from "entities/weather/model/types.ts";
import {useNavigate} from "react-router-dom";

interface WeatherScheduleProps {
  row: ScheduleRow;
}

const WeatherTableBlock = ({ p }: { p: SchedulePart }) => (
  <Row>
    <Part>{p.label}</Part>
    <IconBlock>
      <Temp>
        {p.temp !== null ? `${p.temp > 0 ? "+" : ""}${p.temp}°` : "—"}
      </Temp>

      {p.iconUrl ? (
        <img src={p.iconUrl} alt={p.conditionText} width={32} height={32} />
      ) : (
        <CloudIcon />
      )}

      <Desc>{p.conditionText}</Desc>
    </IconBlock>
    <Cell>
      {p.feelsLike !== null
        ? `${p.feelsLike > 0 ? "+" : ""}${p.feelsLike}°`
        : "—"}
    </Cell>
    <Cell>
      {p.wind.speed !== null
        ? `${p.wind.speed} ${p.wind.arrow} ${p.wind.dirText}`
        : "—"}
    </Cell>
    <Cell>{p.humidity !== null ? `${p.humidity}%` : "—"}</Cell>
    <Cell>{p.pressureMm !== null ? `${p.pressureMm}` : "—"}</Cell>
  </Row>
);

export const WeatherSchedule = (props: WeatherScheduleProps) => {
  const { row } = props;

  const navigate = useNavigate();
  
  const handleToDays = () => {
    navigate(`/weather/${row.dateIso}`);
  };

  return (
    <Table onClick={handleToDays}>
      <Row header>
        <HeaderMainTitle>{row.titleFull}</HeaderMainTitle>
        <Cell />
        <HeaderTitle>ощущается</HeaderTitle>
        <HeaderTitle>ветер, м/с</HeaderTitle>
        <HeaderTitle>влажность</HeaderTitle>
        <HeaderTitle>
          давление,
          <br /> мм. рт. ст.
        </HeaderTitle>
      </Row>

      {row.parts.map((p, i) => (
        <WeatherTableBlock p={p} key={i} />
      ))}

      <Divider />
      <FooterStats>
        <Stat>
          <Drop />
          <span>{row.footer.avgHumidity}%</span>
        </Stat>
        <Stat>
          <Disk />
          <span>{row.footer.avgPressureMm} мм рт. ст.</span>
        </Stat>
      </FooterStats>
    </Table>
  );
};
